import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'app-authorization-error',
  templateUrl: './authorization-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'h-full' },
})
export class AuthorizationErrorComponent {}
